import { render, staticRenderFns } from "./RegistrarCaja.vue?vue&type=template&id=2c94f945&scoped=true&"
import script from "./RegistrarCaja.vue?vue&type=script&lang=js&"
export * from "./RegistrarCaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c94f945",
  null
  
)

export default component.exports